import axios from 'axios';
import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'

// ============ 原子技能管理 ============
const Api = {
  Skill_Page: baseDomain + '/skill/page', // 原子技能分页查询
  Skill_Detail: baseDomain + '/skill/', // 原子技能分页查询
  Skill_Create: baseDomain + '/skill/create', // 新增原子技能
  Skill_Update: baseDomain + '/skill/update', // 编辑原子技能
  Skill_Delete: baseDomain + '/skill/', // 删除原子技能

  Deploy_Skill: baseDomain + '/deploy/skill', // 执行舞种下发
  Deploy_Precheck: baseDomain + '/deploy/precheck', // 设备预检
}

// ============ 原子技能管理 API ============

// 原子技能分页
export const reqSkillPage = (params) => {
  return service({
    url: Api.Skill_Page,
    method: 'POST',
    data: params
  })
}

// 原子技能详情
export const reqSkillDetail = (id) => {
  return service({
    url: Api.Skill_Detail + id,
    method: 'GET',
  })
}

// 新建原子技能
export const reqSkillCreate = (params) => {
  return service({
    url: Api.Skill_Create,
    method: 'POST',
    data: params
  })
}

// 编辑原子技能
export const reqSkillUpdate = (params) => {
  return service({
    url: Api.Skill_Update,
    method: 'PUT',
    data: params
  })
}

// 原子技能
export const reqSkillDelete = (id) => {
  return service({
    url: Api.Skill_Delete + id,
    method: 'DELETE',
  })
}

// 执行原子技能下发
export const reqDeploySkill = (params) => {
  return service({
    url: Api.Deploy_Skill,
    method: 'POST',
    data: params
  })
}

// 设备预检
export const reqDeployPrecheck = (params) => {
  return service({
    url: Api.Deploy_Precheck,
    method: 'POST',
    data: params
  })
}
